import { createAction, props } from '@ngrx/store';

import { Document, Folder } from '@lockton-apps/shared/interfaces';
import {
  DocumentFilterValues,
  DocumentModelNoFolderId,
} from '@lockton-apps/client-gateway/interfaces';

import { ClientDocumentsActionTypes } from './types';

export const init = createAction(ClientDocumentsActionTypes.Init);

export const folderCreated = createAction(
  ClientDocumentsActionTypes.FolderCreated,
  props<{ folderName: string; documents?: DocumentModelNoFolderId[] }>()
);

export const uploadDocumentsClicked = createAction(
  ClientDocumentsActionTypes.UploadDocumentsClicked,
  props<{ files?: File[] }>()
);

export const filesDropped = createAction(
  ClientDocumentsActionTypes.FilesDropped,
  props<{ files: File[] }>()
);

export const listViewTypeChanged = createAction(
  ClientDocumentsActionTypes.ListViewTypeChanged,
  props<{ viewType: string }>()
);

export const documentDownloaded = createAction(
  ClientDocumentsActionTypes.DocumentDownloaded,
  props<{ id: number; name?: string }>()
);

export const documentMoved = createAction(
  ClientDocumentsActionTypes.DocumentMoved,
  props<{ id: number; folderId: number }>()
);

export const documentUpdated = createAction(
  ClientDocumentsActionTypes.DocumentUpdated,
  props<{ document: Partial<Document> }>()
);

// delete
export const documentDeleted = createAction(
  ClientDocumentsActionTypes.DocumentDeleted,
  props<{ id: number }>()
);

export const folderUpdated = createAction(
  ClientDocumentsActionTypes.FolderUpdated,
  props<{ folder: Partial<Folder> }>()
);

export const folderDeleted = createAction(
  ClientDocumentsActionTypes.FolderDeleted,
  props<{ id: number }>()
);

export const filtersChanged = createAction(
  ClientDocumentsActionTypes.FiltersChanged,
  props<{ filters: DocumentFilterValues }>()
);

export const destroyed = createAction(ClientDocumentsActionTypes.Destroyed);
